import { customElement } from 'solid-element';
import { Datatables } from './lib/Datatables';

customElement('solid-datatables', {
    fieldValue: undefined,
    componentDefinition: undefined,
    document: undefined,
    label: undefined,
    mandatory: false,
    enabled: true
}, Datatables);
